var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('van-cell',{attrs:{"title":"宝塔","is-link":"","to":"index"}}),_c('van-cell',{attrs:{"title":"关于售后","is-link":"","to":"/user/afterSales"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }